import { render, staticRenderFns } from "./PageAnalytics.vue?vue&type=template&id=703e2824&scoped=true"
import script from "./PageAnalytics.vue?vue&type=script&lang=js"
export * from "./PageAnalytics.vue?vue&type=script&lang=js"
import style0 from "./PageAnalytics.vue?vue&type=style&index=0&id=703e2824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703e2824",
  null
  
)

export default component.exports